import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { RELATED_PARTY_TYPES } from '../../constants';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { principalType, principalOccupation, principalOtherOccupation },
} = loanFormModel;

export class PrincipalOtherOccupationValidation implements ValidationSchema {
  public name = principalOtherOccupation.name;
  public label = principalOtherOccupation.label;
  public dependsOn: string[] = [principalOccupation.name, principalType.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(principalOccupation: string, principalType: string, schema) {
    if (
      principalOccupation === 'Other' &&
      principalType === RELATED_PARTY_TYPES.INDIVIDUAL
    ) {
      return schema.required(principalOtherOccupation.requiredErrorMsg);
    }
    return schema.notRequired();
  }
}
export default new Validation(new PrincipalOtherOccupationValidation());
